/**
 * Nexoriq brand mark — renders the official raster logo asset (transparent PNG).
 * Two crops shipped in /public/brand:
 *   - nexoriq-logo-full.png     (mark + wordmark + "GLOBAL SUPPLY CHAIN PARTNER") — default
 *   - nexoriq-logo-compact.png  (mark + wordmark only, no tagline)
 *
 * Sizes are height-based; width auto-scales to preserve aspect ratio.
 */
const HEIGHT = {
  sm: 40,
  md: 56,
  lg: 96,
  xl: 140,
};

export default function NexoriqLogo({
  className = "",
  size = "md",
  showTagline = true,
}) {
  const h = HEIGHT[size] ?? HEIGHT.md;
  const src = showTagline
    ? "/brand/nexoriq-logo-full.png"
    : "/brand/nexoriq-logo-compact.png";

  return (
    <span
      className={"inline-flex items-center " + className}
      data-testid="nexoriq-logo"
      aria-label="Nexoriq — Global Supply Chain Partner"
    >
      <img
        src={src}
        alt="Nexoriq — Global Supply Chain Partner"
        style={{ height: h, width: "auto", display: "block" }}
        draggable={false}
      />
    </span>
  );
}
